import { useEffect, useRef } from "react";

export const CustomCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    const dot = dotRef.current;
    const ring = ringRef.current;
    if (!dot || !ring) return;

    let mouseX = 0;
    let mouseY = 0;
    let ringX = 0;
    let ringY = 0;

    const move = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      dot.style.transform = `translate(${mouseX}px, ${mouseY}px) translate(-50%, -50%)`;
    };

    const raf = () => {
      ringX += (mouseX - ringX) * 0.18;
      ringY += (mouseY - ringY) * 0.18;
      ring.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%, -50%)`;
      requestAnimationFrame(raf);
    };
    raf();

    const addHover = () => {
      dot.classList.add("hover");
      ring.classList.add("hover");
    };
    const removeHover = () => {
      dot.classList.remove("hover");
      ring.classList.remove("hover");
    };

    window.addEventListener("mousemove", move);
    const hoverables = document.querySelectorAll(
      "a, button, input, textarea, [data-cursor='hover']"
    );
    hoverables.forEach((el) => {
      el.addEventListener("mouseenter", addHover);
      el.addEventListener("mouseleave", removeHover);
    });

    const observer = new MutationObserver(() => {
      const fresh = document.querySelectorAll(
        "a, button, input, textarea, [data-cursor='hover']"
      );
      fresh.forEach((el) => {
        el.addEventListener("mouseenter", addHover);
        el.addEventListener("mouseleave", removeHover);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener("mousemove", move);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <div ref={ringRef} className="bb-cursor-ring" />
      <div ref={dotRef} className="bb-cursor-dot" />
    </>
  );
};
